import { OrderEventStatus } from "../dto/order-event-status.enum";

	/**
	 * @description
	 *  Modelo de seguimiento de una nota de CyR (cambio y reclamo), o NC
	 *	(nota de crédito), sobre un pedido.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventTrackingForGet.cs
	 */

export class OrderEventTrackingForGet {

	public applicationUserName: string;
	public descriptionStatus: string;
	public id: number;
	public orderEventId: number;
	public orderEventStatus: OrderEventStatus;
	public timestamp: Date;

	/**
	 * @description
	 *	Construye un seguimiento de una nota con una semántica vacía. Nótese
	 *	que no es lo mismo que construir un seguimiento con valores por
	 *	defecto. Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un seguimiento de nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventTrackingForGet {
		const orderEventTrackingForGet: OrderEventTrackingForGet = new OrderEventTrackingForGet();
		orderEventTrackingForGet.applicationUserName = "";
		orderEventTrackingForGet.descriptionStatus = "";
		orderEventTrackingForGet.id = undefined;
		orderEventTrackingForGet.orderEventId = undefined;
		orderEventTrackingForGet.orderEventStatus = undefined;
		orderEventTrackingForGet.timestamp = undefined;
		return orderEventTrackingForGet;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventTrackingForGet
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventTrackingForGet: OrderEventTrackingForGet): OrderEventTrackingForGet {
		if (!anemicOrderEventTrackingForGet) return undefined;
		const orderEventTrackingForGet: OrderEventTrackingForGet = OrderEventTrackingForGet.empty();
		orderEventTrackingForGet.applicationUserName = anemicOrderEventTrackingForGet.applicationUserName;
		orderEventTrackingForGet.descriptionStatus = anemicOrderEventTrackingForGet.descriptionStatus;
		orderEventTrackingForGet.id = anemicOrderEventTrackingForGet.id;
		orderEventTrackingForGet.orderEventId = anemicOrderEventTrackingForGet.orderEventId;
		orderEventTrackingForGet.orderEventStatus = anemicOrderEventTrackingForGet.orderEventStatus;
		orderEventTrackingForGet.timestamp = new Date(anemicOrderEventTrackingForGet.timestamp);
		return orderEventTrackingForGet;
	}
}
